import {getTraitCategoriesUseCase} from '@/useCases/getTraitCategoriesUseCase'
import {useQuery} from '@tanstack/react-query'

export const TRAIT_CATEGORIES_QUERY_KEY = ['traitCategories'] as const

export const useTraitCategories = (retry: boolean | number = 3) =>
  useQuery({
    queryKey: TRAIT_CATEGORIES_QUERY_KEY,
    queryFn: ({signal}: {signal: AbortSignal}) => getTraitCategoriesUseCase(signal),
    retry,
  })
